import { IInspectionsHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

interface IProps {
  orderId?: string;
  vrm?: string;
  customerId?: string;
}

export const useInspections = ({ orderId, vrm, customerId }: IProps): IInspectionsHook => {
  const { inspectionStore } = useStore();
  const {
    inspections,
    loading,
    maxResultCount,
    skipCount,
    totalCount,
    currentPage,
    handlePageChange,
  } = inspectionStore;

  useEffect(() => {
    return () => inspectionStore.resetInspections();
  }, [inspectionStore]);

  useEffect(() => {
    if (orderId || vrm || customerId) {
      inspectionStore.getAll({
        orderId,
        vrm,
        customerId,
        skipCount,
        maxResultCount,
      });
    }
  }, [inspectionStore, orderId, vrm, customerId, skipCount, maxResultCount]);

  return {
    loading,
    totalCount,
    currentPage,
    maxResultCount,
    dataSource: Array.from(inspections.values()),
    handlePageChange,
  };
};
